import * as TogglePrimitive from '@radix-ui/react-toggle';
import * as React from 'react';
import { cn } from '@discover-lib/utils';
import toggleVariants, { type ToggleVariantProps } from './variants';

export type ToggleProps = React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> &
  ToggleVariantProps;

const Toggle = React.forwardRef<React.ElementRef<typeof TogglePrimitive.Root>, ToggleProps>(
  ({ className, kind, scale, width, round, ...props }, ref) => (
    <TogglePrimitive.Root
      ref={ref}
      className={cn(toggleVariants({ kind, scale, width, round }), className)}
      {...props}
    />
  )
);

Toggle.displayName = TogglePrimitive.Root.displayName;

export default Toggle;
